export default __webpack_public_path__ + "static/media/ord-stock-v.e9f0f2cf.png";